import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import plLocale from '@fullcalendar/core/locales/pl';

import { useHolidays } from '../../../utils/useHolidays';
import { useDispatch, useSelector } from 'react-redux';
import {
  addEventRequest,
  deleteEventRequest,
  editEventRequest,
  getEvents,
  loadEventsRequest,
} from '../../../redux/calendarEvent';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import {
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  Modal,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import interactionPlugin from '@fullcalendar/interaction';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getUser } from '../../../redux/usersRedux';
import { io } from 'socket.io-client';
import { SOCKET_URL } from '../../../config';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const calendarEvents = [
  {
    title: 'Urlop',
    id: 'URLOP',
  },

  {
    title: 'Zmiana I',
    id: 'ZMIANA_I',
  },
  {
    title: 'Zmiana II',
    id: 'ZMIANA_II',
  },
  {
    title: 'Zmiana Łamana',
    id: 'ZMIANA_LAMANA',
  },
  {
    title: 'Delegacja',
    id: 'DELEGACJA',
  },
  {
    title: 'Inwentaryzacja',
    id: 'INWENTARYZACJA',
  },
];

const socket = io(SOCKET_URL);

const Calendar = ({ maxEvents, heightBool }) => {
  const user = useSelector((state) => getUser(state));
  const [open, setOpen] = useState(false);
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);
  const [allDay, setAllDay] = useState(true);
  const [title, setTitle] = useState('');
  const [category, setCategory] = useState('');
  const [updateModal, setUpdateModal] = useState(false);
  const [eventId, setEventId] = useState(null);
  const [alert, setAlert] = useState(false);

  const dispatch = useDispatch();
  const holidays = useHolidays({
    country: 'pl',
    apiKey: process.env.REACT_APP_GOOGLE_CALENDAR_API_KEY,
  });
  const normalEvents = useSelector((state) => getEvents(state));

  const handleClose = () => {
    setOpen(false);
    setUpdateModal(false);
  };
  useEffect(() => {
    const start = async () => {
      await dispatch(loadEventsRequest());
    };
    start();
  }, [dispatch]);

  useEffect(() => {
    socket.on('newEvent', (event) => {
      console.log('Otrzymano nowe wydarzenie:', event);
      // Aktualizacja stanu komponentu
      dispatch(loadEventsRequest());
    });
    socket.on('deletedEvent', (eventId) => {
      console.log('Usunięto wydarzenie o ID:', eventId);
      // Aktualizacja stanu komponentu
      dispatch(loadEventsRequest());
    });

    return () => {
      socket.off('newEvent'); // Wyczyść po odmontowaniu
      socket.off('deletedEvent'); // Wyczyść po odmontowaniu
    };
  }, [dispatch]);

  const dayClickAction = (info) => {
    setOpen(true);
  };

  const handleSubmit = async () => {
    const newEvent = {
      title: title,
      start: start,
      end: end,
      allDay: allDay,
      category: category,
      userId: user.users.id,
    };

    console.log(newEvent);

    const createEvent = await dispatch(addEventRequest(newEvent));
    if (createEvent && createEvent.status === 201) {
      setOpen(false);
      setTitle('');
      setStart(null);
      setEnd(null);
      setCategory('');
    }
    console.log(createEvent);
  };

  const handleEventClick = (info) => {
    if (info.event.extendedProps.userId !== user.users.id) {
      setAlert(true);
      return;
    }
    setUpdateModal(true);
    setTitle(
      calendarEvents.find((el) => el.id === info.event.extendedProps.category)
        ?.title || '',
    );
    setCategory(info.event.extendedProps.category);
    setStart(dayjs(info.event.start));
    setEnd(dayjs(info.event.end).subtract(1, 'day'));
    setEventId(info.event.id);
    setOpen(true);
  };

  const handleUpdateSubmit = async () => {
    const updateEvent = {
      id: eventId,
      title: title,
      start: start,
      end: end,
      allDay: allDay,
      category: category,
      userId: user.users.id,
    };

    const res = await dispatch(editEventRequest(updateEvent));
    if (res && res.status === 200) {
      setOpen(false);
      setTitle('');
      setStart(null);
      setEnd(null);
      setCategory('');
      setEventId(null);
      setUpdateModal(false);
    }
  };

  const removeEvent = async () => {
    const res = await dispatch(deleteEventRequest(eventId));

    setOpen(false);
    setTitle('');
    setStart(null);
    setEnd(null);
    setCategory('');
    setEventId(null);
    setUpdateModal(false);
  };

  const handleAlertClose = () => {
    setAlert(false);
  };

  return (
    <>
      <style>{`
        .fc-popover {
          max-width: 400px !important; /* domyślnie ~220px */
          width: 400px !important;
          z-index: 1200 !important;
        }
      `}</style>
      <Snackbar open={alert} autoHideDuration={6000} onClose={handleAlertClose}>
        <Alert
          variant="filled"
          onClose={handleAlertClose}
          severity="error"
          sx={{ width: '100%' }}
        >
          <AlertTitle>Błąd</AlertTitle>
          Brak uprawnień do edycji / usuwania tego wydarzenia!
        </Alert>
      </Snackbar>
      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView={heightBool ? 'dayGridWeek' : 'dayGridMonth'}
        locale={plLocale}
        timeZone="Europe/Warsaw"
        height={heightBool ? '400px' : '100%'}
        dayMaxEvents={maxEvents || 4}
        moreLinkClick={'popover'}
        expandRows={true}
        dateClick={dayClickAction}
        eventClick={handleEventClick}
        eventSources={[
          holidays,
          {
            events: normalEvents,
            eventDataTransform: (eventData) => {
              let color = '#fff';
              let title = eventData.title;

              if (eventData.category === 'URLOP') {
                color = '#4caf50';
                title = `Urlop - ${eventData.user.firstName} ${eventData.user.lastName}`;
              } else if (eventData.category === 'CHOROBOWE') {
                color = '#f44336';
                title = `Chorobowe - ${eventData.user.firstName} ${eventData.user.lastName}`;
              } else if (eventData.category === 'URLOP_OKOLICZNOSCIOWY') {
                color = '#00cbf8ff';
                title = `Urlop okolicznościwy - ${eventData.user.firstName} ${eventData.user.lastName}`;
              } else if (eventData.category === 'ZMIANA_I') {
                color = '#1976d2';
                title = `Zmiana I - ${eventData.user.firstName} ${eventData.user.lastName}`;
              } else if (eventData.category === 'ZMIANA_II') {
                color = '#ff9800';
                title = `Zmiana II - ${eventData.user.firstName} ${eventData.user.lastName}`;
              } else if (eventData.category === 'ZMIANA_LAMANA') {
                color = '#9c27b0';
                title = `Zmiana Łamana - ${eventData.user.firstName} ${eventData.user.lastName}`;
              } else if (eventData.category === 'DELEGACJA') {
                color = '#c2185b';
                title = `Delegacja - ${eventData.user.firstName} ${eventData.user.lastName}`;
              } else if (eventData.category === 'INWENTARYZACJA') {
                color = '#ff5722';
                title = `Inwentaryzacja`;
              } else {
                color = '#1b0268ff'; // nieprzewidziany typ - niebiesony
                title = `Inne - ${eventData.user.firstName} ${eventData.user.lastName}`;
              }

              return {
                ...eventData,
                color: color,
                title: title,
                end:
                  eventData.allDay && eventData.end > eventData.start
                    ? dayjs(eventData.end).add(1, 'day').toDate()
                    : eventData.end,
              };
            },
          },
        ]}
        eventContent={(arg) => {
          // Pobieramy dane użytkownika i kategorię
          const category = arg.event.extendedProps.category;
          const start = arg.event.start;
          const rawEnd = arg.event.end;

          // Dla allDay: end jest ekskluzywny; do wyświetlenia odejmij 1 dzień.
          // Gdy end nie istnieje (null), przyjmij ten sam dzień co start.
          const endForDisplay =
            arg.event.allDay && rawEnd > start
              ? dayjs(rawEnd).subtract(1, 'day')
              : dayjs(rawEnd ?? start);
          // Generujemy treść tooltipa w Material-UI
          return (
            <Tooltip
              sx={{ zIndex: 9999 }}
              title={
                <div style={{ padding: '6px 8px' }}>
                  <Typography variant="subtitle2" fontWeight="bold">
                    {arg.event.title}
                  </Typography>

                  {category && (
                    <Typography variant="body2">
                      Kategoria: {category}
                    </Typography>
                  )}
                  <Typography variant="caption">
                    Od: {dayjs(arg.event.start).format('DD.MM.YYYY')}
                  </Typography>
                  <br />
                  <Typography variant="caption">
                    Do:{' '}
                    {endForDisplay.isValid()
                      ? endForDisplay.format('DD.MM.YYYY')
                      : '—'}
                  </Typography>
                  <br />
                  <Typography variant="caption">
                    Suma dni:{' '}
                    {dayjs(endForDisplay).diff(arg.event.start, 'day') + 1}
                  </Typography>
                </div>
              }
              arrow
              placement="right"
              enterDelay={0} // ⬅️ natychmiastowe wyświetlenie
              leaveDelay={0} // ⬅️ natychmiastowe ukrycie
            >
              <div
                style={{
                  width: '100%',
                  cursor: 'pointer',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {arg.event.title}
              </div>
            </Tooltip>
          );
        }}
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
          >
            Dodaj wydarzenie w kalendarzu
          </Typography>

          <Box sx={{ mt: 2, display: 'flex' }}>
            <Autocomplete
              disablePortal
              id="combo-source"
              sx={{ width: { xs: '50%', md: '40%' }, mb: 2 }}
              options={calendarEvents.map((el) => ({
                id: el.id,
                label: `${el.title}`,
              }))}
              value={title}
              onChange={(e, value) => {
                setCategory(value ? value.id : '');
                setTitle(value ? value.label : '');
              }}
              renderInput={(params) => (
                <TextField {...params} label={'Kategoria wydarzenia'} />
              )}
            />
            <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
              <DateTimePicker
                sx={{ width: { xs: '100%', md: '25%' }, mb: 2, mx: 1 }}
                //   label={t('pz04.hourBlockTo')}

                format="DD.MM.YYYY"
                label="Data rozpoczęcia"
                views={['year', 'month', 'day']}
                value={dayjs(start)}
                onChange={(newValue) => {
                  const dateWithSix = dayjs(newValue)
                    .hour(6)
                    .minute(0)
                    .second(0);
                  setStart(dateWithSix);
                }}
                slotProps={{
                  textField: {
                    error: false,
                  },
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
              <DateTimePicker
                sx={{ width: { xs: '100%', md: '25%' }, mb: 2, mx: 1 }}
                //   label={t('pz04.hourBlockTo')}
                format="DD.MM.YYYY"
                label="Data zakończenienia"
                // views={['year', 'month', 'day', 'hours', 'minutes']}
                views={['year', 'month', 'day']}
                value={dayjs(end)}
                onChange={(newValue) => {
                  const dateWithSix = dayjs(newValue)
                    .hour(6)
                    .minute(0)
                    .second(0);
                  setEnd(dateWithSix);
                }}
                slotProps={{
                  textField: {
                    error: false,
                  },
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </Box>
          {!updateModal ? (
            <Button
              variant="contained"
              sx={{
                mt: 2,
                bgcolor: '#C09A53',
                ':hover': { bgcolor: '#9c7c43' },
              }}
              onClick={handleSubmit}
            >
              Utwórz
            </Button>
          ) : (
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button
                variant="contained"
                sx={{
                  mt: 2,
                  mr: 2,
                  bgcolor: '#C09A53',
                  ':hover': { bgcolor: '#9c7c43' },
                }}
                onClick={handleUpdateSubmit}
              >
                Aktualizuj
              </Button>
              <Button
                variant="contained"
                color="error"
                sx={{
                  mt: 2,

                  // bgcolor: '#C09A53',
                  // ':hover': { bgcolor: '#9c7c43' },
                }}
                onClick={removeEvent}
              >
                Usuń
              </Button>
            </Box>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default Calendar;
